
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/[categorySlug]",
      function () {
        return require("private-next-pages/services/[categorySlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/[categorySlug]"])
      });
    }
  